import React, { useState } from 'react';

import { toast } from 'react-toastify';

import classNames from 'classnames';
import { DateRangePicker } from 'materialui-daterange-picker';

import IconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import TextField from '@material-ui/core/TextField';
import CloseIcon from '@material-ui/icons/Close';

import NibDialog from '@components/common/NibDialog/NibDialog';

import ClearButton from './ClearButton';
import css from './filters.module.sass';

const DateRange = ({
  value,
  aliasStart = 'startDate',
  label = 'Date range',
  aliasEnd = 'endDate',
  onFilter,
  ...props
}) => {
  const [open, setOpen] = useState(false);
  const [dateRange, setDateRange] = useState({});

  const toggle = () => setOpen(!open);

  const onClose = (isAgree) => {
    if (isAgree) {
      if (!dateRange.endDate) return toast.error('Please select end date');
      if (!dateRange.startDate) return toast.error('Please select start date');

      onFilter(aliasStart, new Intl.DateTimeFormat('ru-RU', {}).format(new Date(dateRange.startDate)));
      onFilter(aliasEnd, new Intl.DateTimeFormat('ru-RU', {}).format(new Date(dateRange.endDate)));
      setOpen(false);
    }
    setOpen(false);
  };

  const clear = (e) => {
    e.stopPropagation();
    onFilter(aliasStart, null);
    onFilter(aliasEnd, null);
  };

  const valueIsSet = value?.startDate && value?.endDate;

  return (
    <>
      <TextField
        onClick={toggle}
        inputProps={{
          className: css.cursorPointer,
        }}
        InputProps={{
          endAdornment: valueIsSet ? <ClearButton onClick={clear} /> : null,
        }}
        variant="outlined"
        size="small"
        value={valueIsSet ? `${value.startDate} - ${value.endDate}` : label}
        style={{ width: 250 }}
        className={classNames(valueIsSet ? css.active : '', props.className)}
      />
      <NibDialog open={open} width={'768px'} onClose={onClose} useButtons>
        <DateRangePicker
          wrapperClassName={css.dateRange}
          toggle={() => {}}
          open={true}
          onChange={(range) => {
            setDateRange(range);
          }}
        />
      </NibDialog>
    </>
  );
};

export default DateRange;
